import { EntityName, N2NRelationshipName } from '@provision/entity-types';
import { EventHubEntityN2NRelationshipChangeOperation } from '@provision/event-hub-utils';

/**
 * 1→N mappings: when a child changes, which parent & FK field to use?
 * e.g. Participant → Conversation via conversationId
 */
export const ONE_TO_MANY_RELATIONS: {
  childEntity: EntityName;
  parentEntity: EntityName;
  fkField: string;
}[] = [
  {
    childEntity: 'ConversationParticipation',
    parentEntity: 'Conversation',
    fkField: 'conversationId',
  },
  // add other one→many relationships here
];

/**
 * N2N mappings: when this join‑table changes, which root entities to evict
 */
export const ADDITIONAL_EVICTION_MAP: Partial<
  Record<N2NRelationshipName, { entityName: EntityName; fkField: string }[]>
> = {
  ClientToAddress: [
    { entityName: 'Client', fkField: 'clientId' },
    { entityName: 'Address', fkField: 'addressId' },
  ],
};

export const N2NOperations: EventHubEntityN2NRelationshipChangeOperation[] = [
  'createN2NRelationship',
  'deleteN2NRelationship',
];

export const IGNORE_SORTING_REFETCH_ATTRIBUTES = [
  'createdAt',
  'updatedAt',
  // conversations re-sorting is handled by JS, so it is safe to ignore its fields
  'conversationStatusUpdatedAt',
  'lastMessageReceivedAt',
  'conversationUrgencyId',
  'conversationStatusId',
  'assigneeUpdatedAt',
  'assigneeGroupUpdatedAt',
  'requesterUpdatedAt',
  'workspaceConversationId',
  'subject',
  'conversationId',
];

// the list of queries that should not be immediately refetched
// since they are static enough to wait until user goes to any other page
// to perform an automatic api call or they generic enough to be sure that
// this query will not be stale
export const ignoreImmediateRefetchOnWsReconnectQueries = new Set([
  'GetPartner',
  'GetPlatformUser',
  'GetEnabledRecordFolders',
  'GetNoRelationsPlatformUsers',
  'GetGroupRuleValues',
  'GetConversationStatus',
  'GetEnabledConversationUrgencies',
  'GetBrand',
  'GetBrandGroups',
  'GetEnabledConversationAssigneeGroups',
  'GetEnabledMacros',
  'GetCustomViewAccess',
  'GetProjectLostReason',
  'GetRecordFolderAssignment',
  'GetCustomView',
  'GetUserGroupRule',
  'GetProjectStage',
  'GetPartnerSettingValue',
  'GetPartnerGroupRuleValues',
  'GetConversationParticipantOptions',
  'GetConversation',
  'GetNotificationPreference',
  'GetLabelAssignment',
]);
